import React from 'react'

import ClientAndPatientDetailsPage from './ClientAndPatientDetailsPage'

const NoPatientPage = () => <ClientAndPatientDetailsPage nopet />

export default NoPatientPage
